export const formatMoney = (amount: number) => {
  return amount.toLocaleString('en-US', {
    currency: 'USD',
    maximumFractionDigits: amount ? 2 : 0, // hide cents if amount is 0
    minimumFractionDigits: amount ? 2 : 0, // hide cents if amount is 0
    style: 'currency',
  });
};
